import classNames from 'classnames';
import { ReactElement, ReactNode } from 'react';

import { formatDateRange } from '~/utils/date/date';
import { ICeArchivedExemption, ICeExemption } from '~/services/api/communityEngagement/types';

import AutomaticChip from '../AutomaticChip';
import DocumentList from '../DocumentList';
import ceStyles from '~/ui/pages/Clients/reusable/CommunityEngagement/CommunityEngagement.module.scss';

import styles from './ExemptionRow.module.scss';

interface IExemptionRowProps {
  exemption: ICeExemption | ICeArchivedExemption;
  isArchived?: boolean;
  actions?: ReactNode;
}

const ExemptionRow = ({
  exemption,
  isArchived = false,
  actions,
}: IExemptionRowProps): ReactElement => (
  <div className={ceStyles.row}>
    <div className={ceStyles.rowSummary}>
      {exemption.isAutomatic && <AutomaticChip />}
      <div className={classNames(ceStyles.rowTitle, isArchived && styles.archivedTitle)}>
        {exemption.category.name}
      </div>
      <div className={styles.period}>
        {formatDateRange(exemption.effectiveDate, exemption.expirationDate)}
      </div>
    </div>
    <div className={ceStyles.rowDocuments}>
      <DocumentList documents={exemption.documents} />
    </div>
    {actions}
  </div>
);

export default ExemptionRow;
